
































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { couponTypeMap } from '@/types/package-management/dictionaries';
import Utils from '@/utils/common';
import OrganizationSearch from '@/components/organization-search/index.vue';
import { merchantPackageAccountList, merchantAccountExport } from '@/api/package-management/index';
import { BUSINESS_LIST_DETAIL } from '../../discount-management/router-names';
@Component({
  name: 'PackageBalance',
  components: { ParkingLotSearch, OrganizationSearch }
})
export default class PackageBalance extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    orgId: '',
    merchantName: '',
    packageType: ''
  };
  // options = Utils.toLabelVal(businessTypeMap)
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  businessType = ''; //商家类型
  // orgdepId = ''
  private tableLoading: boolean = false;
  editModel: boolean = false; //弹出框是否显示
  tableData: any[] = [];
  couponTypeList: any[] = Utils.toLabelVal(couponTypeMap) || [];
  canExport: boolean = true;
  isOrgRoot: boolean = true;
  isDetail: boolean = false;
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '商家',
        dataIndex: 'merchantName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '所属机构（项目）',
        dataIndex: 'orgName',
        width: 200
      },
      {
        title: '优惠类型',
        dataIndex: 'packageType',
        width: 160,
        scopedSlots: { customRender: 'packageType' }
      },
      {
        title: '累计购买总额',
        dataIndex: 'totalBuyAmount',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '累计发放总额',
        dataIndex: 'totalSendAmount',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '累计失效总额',
        dataIndex: 'totalInvalidAmount',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '账户剩余',
        dataIndex: 'restQuota',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-16' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 160,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //table初始化
  current = 1;
  pageSize = 10;
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { ...rest } = this.filterParam;
      const { status, code, msg, data } = await merchantPackageAccountList({
        ...rest,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear() {
    this.filterParam = {
      orgId: '',
      merchantName: '',
      packageType: ''
    };
    // @ts-ignore
    this.$refs.orgTree.setRootId();
    this.searchTable();
  }
  //默认选中机构根节点
  selectDefaultRoot(val: any) {
    this.filterParam.orgId = val;
  }
  //查看流水记录
  toRecord(record: { merchantId: any }) {
    console.log(record);
    this.$router.push({
      name: BUSINESS_LIST_DETAIL,
      params: {
        id: record.merchantId,
        activeKey: '2'
      }
    });
  }
  downFlag: boolean = false;
  //导出
  private async downLoad() {
    try {
      if (this.downFlag) return;
      this.downFlag = true;
      const { ...rest } = this.filterParam;
      await merchantAccountExport(
        {
          ...rest,
          currPage: this.current,
          pageSize: this.pageSize
        },
        '商家套餐余额'
      );
    } catch (e) {
      console.log(e);
    } finally {
      this.downFlag = false;
    }
  }
  created() {
    this.fetchTableData();
  }
}
